import { defineRecipe } from '@chakra-ui/react/styled-system';

const linkButtonRecipe = defineRecipe({
  className: 'link-button',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    color: 'text/link',
    cursor: 'pointer',
    gap: '4',
    _hover: {
      color: 'text/link-hover',
      _active: {
        color: 'text/primary',
      },
    },
    _active: {
      color: 'text/primary',
    },
    _disabled: {
      color: 'text/disabled',
      cursor: 'not-allowed',
    },
  },
  variants: {
    size: {
      lg: {
        textStyle: 'body/lg/regular',
      },
      md: {
        textStyle: 'body/md/regular',
      },
      sm: {
        textStyle: 'body/sm/regular',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default linkButtonRecipe;
